module.exports = __webpack_public_path__ + "img/03_bg.e5e4b874.jpg";